<template>
  <!-- 升级模式显示设置 -->
  <a-layout-content>
    <div>
      <a-form layout="inline">
        <a-form-item label="电子链接">
          <a-switch checked-children="开" un-checked-children="关" v-model="slotLink" @click="LinkChecked(1)"
            :disabled="!role94" />
        </a-form-item>
        <a-form-item label="真人链接">
          <a-switch checked-children="开" un-checked-children="关" v-model="liveLink" @click="LinkChecked(2)"
            :disabled="!role94" />
        </a-form-item>
        <a-form-item label="USDT链接">
          <a-switch checked-children="开" un-checked-children="关" v-model="usdtLink" @click="LinkChecked(8)"
            :disabled="!role94" />
        </a-form-item>
        <a-form-item label="借款最高可借款天数">
          <a-input v-model="repayday" />
        </a-form-item>
        <a-form-item label="电子投注备注显示">
          <a-switch checked-children="开" un-checked-children="关" v-model="slotmemoshow" @click="LinkChecked(4)"
            :disabled="!role94" />
        </a-form-item>
        <a-form-item label="真人投注备注显示">
          <a-switch checked-children="开" un-checked-children="关" v-model="livememoshow" @click="LinkChecked(5)"
            :disabled="!role94" />
        </a-form-item>
        <a-form-item label="USDT存款备注显示">
          <a-switch checked-children="开" un-checked-children="关" v-model="usdtmemoshow" @click="LinkChecked(9)"
            :disabled="!role94" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="repaydayBtn()">保存</a-button>
        </a-form-item>
      </a-form>
    </div>
    <div>
      <a-tabs default-active-key="1" @change="callback">
        <a-tab-pane key="1" tab="电子选单(PC版)">
          <a-table :columns="columns" :data-source="headData" bordered :pagination="false" row-key="ID" size="middle">
            <template slot="title">
              <a-row :gutter="24">
                <a-col :span="6" style="line-height: 30px">导航链接</a-col>
                <a-col style="float: right" v-if="role91">
                  <a-button type="primary" @click="add(1, 1)">新增链接</a-button>
                </a-col>
              </a-row>
            </template>
            <template slot="operate" slot-scope="text, record">
              <template v-if="role91">
                <a-tooltip>
                  <template slot="title"> 编辑 </template>
                  <a href="javascript:;" @click="onEdit(record)">
                    <a-icon type="edit" style="font-size: 22px"></a-icon>
                  </a>
                </a-tooltip>
                &nbsp;
              </template>
              <template v-if="role93">
                <a-tooltip>
                  <template slot="title"> 删除 </template>
                  <a-popconfirm title="确定要删除?" @confirm="() => onDelete(record)">
                    <a href="javascript:;">
                      <a-icon type="delete" style="font-size: 22px"></a-icon>
                    </a>
                  </a-popconfirm>
                </a-tooltip>
              </template>
            </template>
          </a-table>
          <br />
          <a-table :columns="columns" :data-source="lateData" bordered :pagination="false" row-key="ID" size="middle">
            <template slot="title">
              <a-row :gutter="24">
                <a-col :span="6" style="line-height: 30px">底部链接</a-col>
                <a-col style="float: right" v-if="role91">
                  <a-button type="primary" @click="add(1, 2)">新增链接</a-button>
                </a-col>
              </a-row>
            </template>
            <template slot="operate" slot-scope="text, record">
              <template v-if="role91">
                <a-tooltip>
                  <template slot="title"> 编辑 </template>
                  <a href="javascript:;" @click="onEdit(record)">
                    <a-icon type="edit" style="font-size: 22px"></a-icon>
                  </a>
                </a-tooltip>
                &nbsp;
              </template>
              <a-tooltip v-if="role93">
                <template slot="title"> 删除 </template>
                <a-popconfirm title="确定要删除?" @confirm="() => onDelete(record)">
                  <a href="javascript:;">
                    <a-icon type="delete" style="font-size: 22px"></a-icon>
                  </a>
                </a-popconfirm>
              </a-tooltip>
            </template>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="2" tab="真人选单(PC版)" force-render>
          <a-table :columns="columns" :data-source="headData" bordered :pagination="false" row-key="ID" size="middle">
            <template slot="title">
              <a-row :gutter="24">
                <a-col :span="6" style="line-height: 30px">导航链接</a-col>
                <a-col style="float: right" v-if="role91">
                  <a-button type="primary" @click="add(2, 1)">新增链接</a-button>
                </a-col>
              </a-row>
            </template>
            <template slot="operate" slot-scope="text, record">
              <template v-if="role91">
                <a-tooltip>
                  <template slot="title"> 编辑 </template>
                  <a href="javascript:;" @click="onEdit(record)">
                    <a-icon type="edit" style="font-size: 22px"></a-icon>
                  </a>
                </a-tooltip>
                &nbsp;
              </template>
              <a-tooltip v-if="role93">
                <template slot="title"> 删除 </template>
                <a-popconfirm title="确定要删除?" @confirm="() => onDelete(record)">
                  <a href="javascript:;">
                    <a-icon type="delete" style="font-size: 22px"></a-icon>
                  </a>
                </a-popconfirm>
              </a-tooltip>
            </template>
          </a-table>
          <br />
          <a-table :columns="columns" :data-source="lateData" bordered :pagination="false" row-key="ID" size="middle">
            <template slot="title">
              <a-row :gutter="24">
                <a-col :span="6" style="line-height: 30px">底部链接</a-col>
                <a-col style="float: right" v-if="role91">
                  <a-button type="primary" @click="add(2, 2)">新增链接</a-button>
                </a-col>
              </a-row>
            </template>
            <template slot="operate" slot-scope="text, record">
              <template v-if="role91">
                <a-tooltip>
                  <template slot="title"> 编辑 </template>
                  <a href="javascript:;" @click="onEdit(record)">
                    <a-icon type="edit" style="font-size: 22px"></a-icon>
                  </a>
                </a-tooltip>
                &nbsp;
              </template>
              <a-tooltip v-if="role93">
                <template slot="title"> 删除 </template>
                <a-popconfirm title="确定要删除?" @confirm="() => onDelete(record)">
                  <a href="javascript:;">
                    <a-icon type="delete" style="font-size: 22px"></a-icon>
                  </a>
                </a-popconfirm>
              </a-tooltip>
            </template>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="3" tab="自定义链结" force-render>
          <a-form layout="inline" style="height: 50px; margin-left: 10px;">
            <a-form-item label="链接类型">
              <a-select v-model="TypeUrl" style="width: 183px" @change="qryUrlListAPI()">
                <a-select-option value="1"> 借呗</a-select-option>
                <a-select-option value="2"> 优惠活动大厅</a-select-option>
                <a-select-option value="3"> 交易账号</a-select-option>
                <a-select-option value="4"> 电子竞技榜</a-select-option>
                <a-select-option value="5"> 翻本金</a-select-option>
                <a-select-option value="6"> 电子升级</a-select-option>
                <a-select-option value="7"> 真人升级</a-select-option>
                <a-select-option value="8"> USDT存款</a-select-option>
                <a-select-option value="9"> 会员VIP</a-select-option>
                <a-select-option value="10"> 自助客服</a-select-option>
                <a-select-option value="11"> 代理活动</a-select-option>
              </a-select>
            </a-form-item>
          </a-form>
          <a-table bordered :columns="lendUrlColumns" :data-source="lendUrlData" :pagination="false" row-key="Type"
            size="middle">
            <template slot="operate" slot-scope="text, record">
              <a-tooltip v-if="role92">
                <template slot="title"> 编辑 </template>
                <a href="javascript:;" @click="onEdit(record)">
                  <a-icon type="edit" style="font-size: 22px"></a-icon>
                </a>
              </a-tooltip>
            </template>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="4" tab="存款类型" force-render>
          <a-table :columns="Typecolumns" :data-source="paytypeData" bordered :pagination="false" row-key="ID"
            size="middle">
            <template slot="title">
              <a-row :gutter="24">
                <a-col :span="6" style="line-height: 30px">支付类型</a-col>
                <a-col style="float: right" v-if="role120">
                  <a-button type="primary" @click="payTypeEditor()">新增类型</a-button>
                </a-col>
              </a-row>
            </template>
            <template slot="operate" slot-scope="text, record">
              <template v-if="role120">
                <a-tooltip>
                  <template slot="title"> 编辑 </template>
                  <a href="javascript:;" @click="payTypeEditor(record)">
                    <a-icon type="edit" style="font-size: 22px"></a-icon>
                  </a>
                </a-tooltip>
                &nbsp;
              </template>
              <a-tooltip v-if="role120 && (!cantdeltype.includes(record.ID))">
                <template slot="title"> 删除 </template>
                <a-popconfirm title="确定要删除?" @confirm="() => PayTypeDelete(record)">
                  <a href="javascript:;">
                    <a-icon type="delete" style="font-size: 22px"></a-icon>
                  </a>
                </a-popconfirm>
              </a-tooltip>
            </template>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="5" tab="在线付款" force-render>
          <a-form layout="inline" style="margin-bottom: 10px;">
            <a-form-item label="支付类型">
              <a-select v-model="payType" style="width: 120px" @change="queryPayType()">
                <a-select-option v-for="item in selectPayType" :key="item.ID">
                  {{ item.Name }}
                </a-select-option>
              </a-select>
            </a-form-item>
            <!-- <a-form-item>
              <a-button type="primary" @click="qryPayDataAPI()">查询</a-button>
            </a-form-item> -->
            <a-form-item>
              <a-button type="primary" @click="payEditor()">新增途径</a-button>
            </a-form-item>
          </a-form>
          <a-table :columns="payColumns" :data-source="payData" bordered :pagination="false" row-key="ID" size="middle">
            <template slot="operate" slot-scope="text, record">
              <template v-if="role117">
                <a-tooltip>
                  <template slot="title"> 编辑 </template>
                  <a href="javascript:;" @click="payEditor(record)">
                    <a-icon type="edit" style="font-size: 22px"></a-icon>
                  </a>
                </a-tooltip>
              </template>
              &nbsp;
              <a-tooltip title="二维码上传" v-if="record.ShowImg == 1">
                <a href="javascript:;" @click="onUpdateImage(record)">
                  <a-icon type="upload" style="font-size: 22px"></a-icon>
                </a>
              </a-tooltip>
              <template v-if="role118">
                &nbsp;
                <a-tooltip>
                  <template slot="title"> 删除 </template>
                  <a-popconfirm title="确定要删除?" @confirm="() => onPayDelete(record)">
                    <a href="javascript:;">
                      <a-icon type="delete" style="font-size: 22px"></a-icon>
                    </a>
                  </a-popconfirm>
                </a-tooltip>
              </template>
            </template>
          </a-table>
        </a-tab-pane>

      </a-tabs>
    </div>
    <!-- 对话框 ------------------------------------->
    <a-modal v-model="visible" title="新增/编辑" @ok="modalOk">
      <a-form-model ref="ruleForm" :rules="rules" :model="formModel" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="名称" ref="Name" prop="Name">
          <a-input v-model="formModel.Name" :disabled="likeType == '3'" />
        </a-form-model-item>
        <a-form-model-item label="链接" ref="Link" prop="Link">
          <a-input v-model="formModel.Link" />
        </a-form-model-item>
        <a-form-model-item label="排序" ref="Sort" prop="Sort" v-if="likeType !== '3'">
          <a-input v-model.number="formModel.Sort" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 支付途径对话框 ------------------------------------->
    <a-modal v-model="visiblePay" title="新增/编辑" @ok="setPayOk">
      <a-form-model ref="payForm" :rules="rulesPay" :model="formPayModel" :label-col="labelCol"
        :wrapper-col="wrapperCol">
        <a-form-model-item :label="labelPayModel.BankName" ref="BankName" prop="BankName">
          <a-input v-model="formPayModel.BankName" />
        </a-form-model-item>
        <a-form-model-item :label="labelPayModel.Name" ref="Name" prop="Name">
          <a-input v-model="formPayModel.Name" />
        </a-form-model-item>
        <a-form-model-item :label="labelPayModel.BankCard" ref="BankCard" prop="BankCard">
          <a-input v-model="formPayModel.BankCard" />
        </a-form-model-item>
        <a-form-model-item v-if="labelPayModel.Type == 1" :label="labelPayModel.Address" ref="Address" prop="Address">
          <a-input v-model="formPayModel.Address" />
        </a-form-model-item>
        <a-form-model-item label="显示汇率">
          <a-switch checked-children="开" un-checked-children="关" v-model="formPayModel.ShowRate" />
        </a-form-model-item>
        <a-form-model-item label="汇率" ref="Rate" prop="Rate">
          <a-input v-model="formPayModel.Rate" />
        </a-form-model-item>
        <a-form-model-item label="显示二维码">
          <a-switch checked-children="开" un-checked-children="关" v-model="formPayModel.ShowImg" />
        </a-form-model-item>
        <a-form-model-item label="备注" ref="Memo" prop="Memo">
          <a-textarea v-model="formPayModel.Memo" :auto-size="{ minRows: 3, maxRows: 10 }"
            style="width: 300px;"></a-textarea>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 支付类型对话框 ------------------------------------->
    <a-modal v-model="visiblePayType" title="支付类型新增/编辑" @ok="setPayTypeOk">
      <a-form-model ref="payTypeForm" :rules="rulesPayType" :model="formPayTypeModel" :label-col="labelCol"
        :wrapper-col="wrapperCol">
        <a-form-model-item :label="labelPayTypeModel.Name" ref="Name" prop="Name">
          <a-input v-model="formPayTypeModel.Name" />
        </a-form-model-item>
        <a-form-model-item :label="labelPayTypeModel.Status" ref="Status" prop="Status">
          <a-switch checked-children="正常" un-checked-children="停用" :checked="formPayTypeModel.Status.toString() == '1'"
            @change="swichstate($event)" />
        </a-form-model-item>
        <a-form-model-item :label="labelPayTypeModel.UpdateImage" ref="Status" prop="Status">
          <a-switch checked-children="是" un-checked-children="否"
            :checked="formPayTypeModel.UpdateImage.toString() == '1'" @change="swichUpdateImage($event)" />
        </a-form-model-item>
        <a-form-model-item :label="labelPayTypeModel.Sort" ref="Sort" prop="Sort">
          <a-input v-model="formPayTypeModel.Sort" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>

    <!-- 二维码对话框 ------------------------------------->
    <a-modal v-model="visibleImg" title="上传二维码" @ok="UploadOK">
      <a-form-model :model="formModelImg" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-form-model-item label="二维码图片">
          <img style="width: 100px; height: 100px" v-if="pcimageUrl" :src="pcimageUrl" alt="avatar" />
          <a-upload :before-upload="pcUpload" list-type="picture" :file-list="pcfile" :remove="pcRemove">
            <a-button> <a-icon type="upload" /> 选取图片 </a-button>
          </a-upload>
        </a-form-model-item>
      </a-form-model>
    </a-modal>

  </a-layout-content>
</template>
<script>
  import { isSpecialStr, isNumber } from "../../js/textverify";

  export default {
    data() {
      return {
        /*** 权限
         * 91	修改链接
          92	修改借呗支付链接
          93	删除链接
          94	开启/禁用链接
          95	查询链接状态
          96	查询链接
          114	查询借呗支付链接
          116	查询支付途径
          117	编辑支付途径
          118	删除支付途径
          119	查询支付类型
          120	编辑支付类型
         */
        role120: false,
        role119: false,
        role118: false,
        role117: false,
        role116: false,
        role114: false,
        role96: false,
        role95: false,
        role94: false,
        role93: false,
        role92: false,
        role91: false,
        likeType: 1,
        slotLink: true,
        liveLink: true,
        usdtLink: true,
        slotmemoshow: false,
        livememoshow: false,
        usdtmemoshow: false,
        repayday: undefined,
        visible: false, //弹框状态
        formModel: {}, // 弹框字段
        labelCol: { span: 5 },
        wrapperCol: { span: 14 },
        visiblePay: false,
        visiblePayType: false,
        formPayModel: {},
        formPayTypeModel: {
          ID: 0,
          Name: "",
          Sort: 1,
          Status: 1,
          UpdateImage: 0
        },
        payType: undefined,
        isBank: 0,
        selectPayType: [],
        headData: [],
        lateData: [],
        payData: [],
        paytypeData: [],
        cantdeltype: [1, 2, 3, 4],
        payTypeID: undefined,
        columns: [
          {
            title: "名称",
            dataIndex: "Name",
          },
          {
            title: "链接",
            dataIndex: "Link",
          },
          {
            title: "排序",
            dataIndex: "Sort",
          },
          {
            title: "操作",
            dataIndex: "operate",
            align: "center",
            scopedSlots: { customRender: "operate" },
          },
        ],
        payColumns: [
          {
            title: "银行名称",
            dataIndex: "BankName",
          },
          {
            title: "持卡人姓名",
            dataIndex: "Name",
          },
          {
            title: "卡号",
            dataIndex: "BankCard",
          },
          {
            title: "开户地址",
            dataIndex: "Address",
          },
          {
            title: "显示汇率",
            dataIndex: "ShowRate",
            customRender: (text) => {
              switch (text) {
                case 0:
                  text = "关";
                  break;
                case 1:
                  text = "开";
                  break;
              }
              return text;
            },
          },
          {
            title: "显示二维码",
            dataIndex: "ShowImg",
            customRender: (text) => {
              switch (text) {
                case 0:
                  text = "关";
                  break;
                case 1:
                  text = "开";
                  break;
              }
              return text;
            },
          },
          {
            title: "备注",
            dataIndex: "Memo",
          },
          {
            title: "操作",
            dataIndex: "operate",
            align: "center",
            scopedSlots: { customRender: "operate" },
          },
        ],
        Typecolumns: [
          {
            title: "ID",
            dataIndex: "ID",
          },
          {
            title: "名称",
            dataIndex: "Name",
          },
          {
            title: "是否上传图片",
            dataIndex: "UpdateImage",
            customRender: (text) => {
              switch (text) {
                case 0:
                  text = "否";
                  break;
                case 1:
                  text = "是";
                  break;
              }
              return text;
            },
          },
          {
            title: "排序",
            dataIndex: "Sort",
          },
          {
            title: "状态",
            dataIndex: "Status",
            customRender: (text) => {
              switch (text) {
                case 0:
                  text = "停用";
                  break;
                case 1:
                  text = "正常";
                  break;
              }
              return text;
            },
          },
          {
            title: "操作",
            dataIndex: "operate",
            align: "center",
            scopedSlots: { customRender: "operate" },
          },
        ],
        lendUrlData: [],
        lendUrlColumns: [
          {
            title: "名称",
            dataIndex: "Name",
          },
          {
            title: "链接",
            dataIndex: "Link",
          },
          {
            title: "操作",
            dataIndex: "operate",
            align: "center",
            scopedSlots: { customRender: "operate" },
          },
        ],
        rules: {
          Name: [
            { required: true, message: "请输入名称", trigger: "blur" },
          ],
          Sort: [
            { required: true, message: "请输入排序", trigger: "blur" },
            { validator: isNumber, trigger: "change" },
          ],
          Link: [{ required: true, message: "请输入链接", trigger: "blur" }],
        },
        rulesPay: {
          BankName: [
            { required: true, message: "此栏位必填", trigger: "blur" },
            { min: 1, max: 25, message: '长度应该是1到25', trigger: 'blur' },
          ],
          Name: [
            { required: true, message: "此栏位必填", trigger: "blur" },
            { min: 1, max: 25, message: '长度应该是1到25', trigger: 'blur' },
          ],
          BankCard: [
            { required: true, message: "此栏位必填", trigger: "blur" },
            { min: 1, max: 50, message: '长度应该是1到50', trigger: 'blur' },
          ],
          Address: [
            { required: true, message: "此栏位必填", trigger: "blur" },
            { min: 1, max: 50, message: '长度应该是1到50', trigger: 'blur' },
          ],
          Memo: [
            { required: true, message: "此栏位必填", trigger: "blur" },
            { min: 1, max: 200, message: '长度应该是1到200', trigger: 'blur' },
          ]
        },
        rulesPayType: {
          Name: [
            { required: true, message: "此栏位必填", trigger: "blur" },
            { min: 1, max: 50, message: '限制最大长度为50', trigger: 'blur' },
          ],
          Sort: [
            { required: true, message: "此栏位必填", trigger: "blur" }
          ]
        },
        labelPayModel: {},
        labelPayTypeModel: {
          Name: "类型名称", Status: "状态",
          UpdateImage: "是否上传图片", Sort: "排序"
        },
        TypeUrl: "1",
        visibleImg: false,
        formModelImg: {},
        pcimageUrl: false,
        pcfile: [],
      };
    },
    methods: {
      qryListAPI() {
        this.axios
          .post("/ReceptionSet/GetSysClientMenuList", { Type: this.likeType })
          .then((res) => {
            if (res.data) {
              this.headData = [];
              this.lateData = [];
              res.data.forEach((element) => {
                if (element.Position === 1) {
                  this.headData.push(element);
                } else if (element.Position === 2) {
                  this.lateData.push(element);
                }
              });
            }
          });
      },
      qryUrlListAPI() {
        this.axios
          .post("/ReceptionSet/GetSysUrlList", { Type: this.TypeUrl })
          .then((res) => {
            if (res.data) {
              this.lendUrlData = res.data;
            }
          });
      },
      callback(key) {
        this.likeType = key;
        if (key === "3") {
          this.qryUrlListAPI();
        }
        else if (key === "5") {
          this.qryPayTypeSettingAPI();
        }
        else if (key === "4") {
          this.qryPayTypeAPI();
        }
        else {
          this.qryListAPI();
        }
      },
      // 编辑
      onEdit(data) {
        this.visible = true;
        this.formModel = { ...data };
      },
      // 编辑确认
      modalOk() {
        let reqAdd = "/ReceptionSet/SaveSysClientMenu";
        if (this.likeType === "3") {
          reqAdd = "/ReceptionSet/SaveSysUrl";
        }
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            // 弹框确认动作
            this.axios
              .post(reqAdd, this.formModel)
              .then((res) => {
                if (res.data) {
                  this.$message.success("编辑成功");
                  if (this.likeType === "3") {
                    this.qryUrlListAPI();
                  }
                  else {
                    this.qryListAPI();
                  }

                  this.visible = false;
                }
              });
          }
        });
      },
      // 删除
      onDelete(data) {
        this.axios
          .post("/ReceptionSet/DeleteSysClientMenu", { ID: data.ID })
          .then((res) => {
            if (res.data) {
              this.$message.success("删除成功");
              this.qryListAPI();
            }
          });
      },
      // 添加
      add(type, position) {
        this.visible = true;
        this.formModel = {};
        this.formModel.Type = type;
        this.formModel.Position = position;
      },
      // 开启/禁用链接
      LinkChecked(type) {
        let state = this.slotLink ? 1 : 0;
        if (type === 2) {
          state = this.liveLink ? 1 : 0;
        }
        else if (type === 4) {
          state = this.slotmemoshow ? 1 : 0;
        }
        else if (type === 5) {
          state = this.livememoshow ? 1 : 0;
        }
        else if (type === 8) {
          state = this.usdtLink ? 1 : 0;
        }
        else if (type === 9) {
          state = this.usdtmemoshow ? 1 : 0;
        }

        this.axios
          .post("/ReceptionSet/SaveSysSet", { Type: type, ID: state })
          .then((res) => {
            if (res.data) {
              this.$message.success("设置成功");
              this.qryListAPI();
            }
          });
      },
      // 查询链接状态
      QrySysSet() {
        this.axios.post("/ReceptionSet/GetSysSet", {}).then((res) => {
          if (res.data) {
            this.slotLink = res.data[0].SlotLevelState == 0 ? false : true;
            this.liveLink = res.data[0].LiveLevelState == 0 ? false : true;
            this.repayday = res.data[0].RePayDay;
            this.slotmemoshow = res.data[0].SlotBetShowMemo == 0 ? false : true;
            this.livememoshow = res.data[0].LiveBetShowMemo == 0 ? false : true;
            this.usdtLink = res.data[0].UsdtLevelState == 0 ? false : true;
            this.usdtmemoshow = res.data[0].UsdtShowMemo == 0 ? false : true;
          }
        });
      },
      //最高可借款天数保存
      repaydayBtn() {
        const numReg = /^\+?[1-9][0-9]*$/
        var numRe = new RegExp(numReg)
        if (!numRe.test(this.repayday)) {
          this.$message.error("请求输入正整数!");
          return;
        }
        this.axios
          .post("/ReceptionSet/SaveSysSet", { Type: 3, ID: this.repayday })
          .then((res) => {
            if (res.data) {
              this.$message.success("设置成功");
            }
          });
      },
      //支付类型商号设定
      qryPayTypeSettingAPI() {
        this.axios
          .post("/ReceptionSet/GetRepayType", { TypeID: 1, ID: 0 })
          .then((res) => {
            if (res.data) {
              var boo = this.payType === undefined;
              this.selectPayType = res.data;
              if (res.data.length > 0) {
                this.payType = res.data[0].ID;
                this.isBank = res.data[0].isBank;
                this.queryPayType();
                if (boo) {
                  this.qryPayDataAPI();
                }
              }
            }
          });
      },
      //支付途径列
      qryPayDataAPI() {
        let that = this;
        this.axios
          .post("/ReceptionSet/GetRepayTypeSetting", { TypeID: 2, ID: this.payType })
          .then((res) => {
            if (res.data) {
              this.payData = res.data;
            }
          });
      },
      //支付途径新增、编辑按钮
      payEditor(data) {
        if (!this.role117) {
          this.$message.error("暂无权限!");
          return;
        }
        this.visiblePay = true;
        if (data == undefined) {
          this.formPayModel = { ID: 0, TypeID: 0, Address: "", ShowRate: false, ShowImg: false, Rate: "" };
        }
        else {
          this.formPayModel = { ...data };
          this.formPayModel.ShowRate = data.ShowRate == 1 ? true : false;
          this.formPayModel.ShowImg = data.ShowImg == 1 ? true : false;
        }
      },
      //支付途径编辑确认
      setPayOk() {
        this.$refs.payForm.validate((valid) => {
          if (valid) {
            if (this.formPayModel.TypeID == 0) {
              this.formPayModel.TypeID = this.payType;
            }
            var para = { ...this.formPayModel }
            para.ShowRate = this.formPayModel.ShowRate == true ? 1 : 0;
            para.ShowImg = this.formPayModel.ShowImg == true ? 1 : 0;
            //弹框确认动作
            this.axios
              .post("/ReceptionSet/SaveRepayTypeSetting", para)
              .then((res) => {
                if (res.data) {
                  this.$message.success("编辑成功");
                  this.qryPayDataAPI();
                  this.visiblePay = false;
                }
              });
          }
        });
      },
      //下拉框联动
      queryPayType() {
        if (this.isBank == 1) {
          this.payColumns = [
            {
              title: "银行名称",
              dataIndex: "BankName",
            },
            {
              title: "持卡人姓名",
              dataIndex: "Name",
            },
            {
              title: "卡号",
              dataIndex: "BankCard",
            },
            {
              title: "开户地址",
              dataIndex: "Address",
            },
            {
              title: "显示汇率",
              dataIndex: "ShowRate",
              customRender: (text) => {
                switch (text) {
                  case 0:
                    text = "关";
                    break;
                  case 1:
                    text = "开";
                    break;
                }
                return text;
              },
            },
            {
              title: "显示二维码",
              dataIndex: "ShowImg",
              customRender: (text) => {
                switch (text) {
                  case 0:
                    text = "关";
                    break;
                  case 1:
                    text = "开";
                    break;
                }
                return text;
              },
            },
            {
              title: "备注",
              dataIndex: "Memo",
            },
            {
              title: "操作",
              dataIndex: "operate",
              align: "center",
              scopedSlots: { customRender: "operate" },
            },
          ];
          this.labelPayModel = {
            BankName: "银行名称", Name: "持卡人姓名", BankCard: "卡号",
            Address: "开户地址", ShowRate: "否", ShowImg: "否", Memo: "备注", Type: 1,
          };
        }
        else {
          this.payColumns = [
            {
              title: "提示",
              dataIndex: "BankName",
            },
            {
              title: "姓名",
              dataIndex: "Name",
            },
            {
              title: "账号",
              dataIndex: "BankCard",
            },
            {
              title: "备注",
              dataIndex: "Memo",
            },
            {
              title: "操作",
              dataIndex: "operate",
              align: "center",
              scopedSlots: { customRender: "operate" },
            },
          ];
          this.labelPayModel = { Type: 2, BankName: "提示", Name: "姓名", BankCard: "账号", Memo: "备注" };
        }
        this.qryPayDataAPI();
      },
      // 删除支付途径
      onPayDelete(data) {
        this.axios
          .post("/ReceptionSet/DeleteRepayTypeSetting", { ID: data.ID })
          .then((res) => {
            if (res.data) {
              this.$message.success("删除成功");
              this.qryPayDataAPI();
            }
          });
      },
      //支付类型(页签)
      qryPayTypeAPI() {
        let that = this;
        this.axios
          .post("/ReceptionSet/GetRepayType", { TypeID: 1, ID: 0 })
          .then((res) => {
            if (res.data) {
              that.paytypeData = res.data;
            }
          });
      },
      //支付类型新增、编辑按钮
      payTypeEditor(data) {
        if (!this.role119) {
          this.$message.error("暂无权限!");
          return;
        }
        this.visiblePayType = true;
        if (data != undefined) {
          this.formPayTypeModel = { ...data };
        }
        else {
          this.formPayTypeModel.ID = 0;
          this.formPayTypeModel.Name = "";
          this.formPayTypeModel.Sort = 0;
          this.formPayTypeModel.UpdateImage = 0;
          this.formPayTypeModel.Type = 1;
        }
      },
      // 删除支付类型
      PayTypeDelete(data) {
        this.axios
          .post("/ReceptionSet/SaveRepayType", { ID: data.ID, Type: 3 })
          .then((res) => {
            if (res.data) {
              this.$message.success("删除成功");
              this.qryPayTypeAPI();
            }
          });
      },
      //支付途径编辑确认
      setPayTypeOk() {
        this.$refs.payTypeForm.validate((valid) => {
          if (valid) {
            //弹框确认动作
            if (this.formPayTypeModel.ID === 0) { //新增
              this.formPayTypeModel.Type = 1;
            }
            else {
              this.formPayTypeModel.Type = 2;
            }

            this.axios
              .post("/ReceptionSet/SaveRepayType", this.formPayTypeModel)
              .then((res) => {
                if (res.data) {
                  this.$message.success("编辑成功");
                  this.qryPayTypeAPI();
                  this.visiblePayType = false;
                }
              });
          }
        });
      },
      swichstate(val) {
        this.formPayTypeModel.Status = val ? "1" : "0";
      },
      swichUpdateImage(val) {
        this.formPayTypeModel.UpdateImage = val ? "1" : "0";
      },
      isExcel(file) {
        return /\.(jpg|png)$/.test(file.name);
      },
      //上传二维码
      onUpdateImage(data) {
        this.formModelImg = { ...data };
        this.pcfile = [];
        //图片显示
        if (this.formModelImg.ShowImg == true) {
          this.pcimageUrl = this.formModelImg.QrcodeImg;
        }
        this.visibleImg = true;
      },
      pcRemove(file) {
        const index = this.pcfile.indexOf(file);
        const newFileList = this.pcfile.slice();
        newFileList.splice(index, 1);
        this.pcfile = newFileList;
      },
      pcUpload(file) {
        if (!this.isExcel(file)) {
          this.$message.error("仅支持上传.jpg、.png、后缀文件");
          return false;
        }
        this.pcfile = [file];
        return false;
      },
      UploadOK() {
        let param = new FormData();
        if (this.pcfile.length > 0) {
          param.append(
            "files",
            this.pcfile[0],
            "PC." + this.pcfile[0].name.split(".")[1]
          );
        }
        param.append("id", this.formModelImg.ID); // 添加form表单中其他数据
        let config = {
          headers: { "Content-Type": "multipart/form-data" },
        };
        // 添加请求头
        let _this = this;
        this.axios.post("/ReceptionSet/uploadimage", param, config).then((res) => {
          if (res.data) {
            _this.$message.success("上传成功");
            _this.visibleImg = false;
            _this.qryPayTypeAPI();
          }
        });
      },
    },
    //首次加载
    created() {
      this.qryListAPI();
      this.QrySysSet();
      //获取权限
      const array = JSON.parse(sessionStorage.RoleID);
      const roleID = [91, 92, 93, 94, 95, 96, 114, 116, 117, 118, 119, 120];
      var isRole = roleID.filter(function (item) {
        return array.indexOf(item) != -1
      });
      //功能权限获取
      isRole.forEach(element => {
        this["role" + element] = true;
      });
    },
  };
</script>

<style>
  .red {
    color: rgb(255, 0, 0);
  }

  .marr10 {
    margin-right: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/receptionset/upgradedomain.vue